export default __webpack_public_path__ + "static/media/elektrisches-ausgabesystem.6209dab9.webp";